module.exports = __webpack_public_path__ + "57bf13803dd001d61180f9f67c30aeb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/agm-700.png
// module id = 165
// module chunks = 1